import { FC } from 'react';
import { Text } from '@doda/io-react/common';
import { JobRelatedInfoResponse } from '@doda/api-client/aspida/@types';
import { useToggle } from 'hooks/useToggle';
import styles from './index.module.scss';
import { useRelationInformationList } from '../../hooks/useRelationInformationList';
import { RelationInformationList } from './RelationInformationList';

/**
 * RelationInformationのprops
 */
interface Props {
  initialRelationInfoList: JobRelatedInfoResponse[];
  jid: string;
  corporateClientId: string;
}

/**
 * 関連情報コンポーネント
 * @param initialRelationInfoList 初期状態の関連情報リスト
 * @param jid 企業ID
 * @param corporateClientId 法人顧客ID
 */
export const RelationInformation: FC<Props> = ({
  initialRelationInfoList,
  jid,
  corporateClientId,
}) => {
  const [isOpen, toggle] = useToggle();
  const {
    relationInfoList,
    isFetchedAllInfoList,
    fetchRelationInfoListPaginate,
  } = useRelationInformationList(
    initialRelationInfoList,
    jid,
    corporateClientId,
    toggle
  );

  return (
    <section className={styles['jobSearchDetail-relationInformation']}>
      <Text as="h2" color="black_pc" size="20" weight="bold">
        関連情報
      </Text>
      <div className={styles['jobSearchDetail-relationInformation__body']}>
        <Text as="p" color="black_pc" size="16" weight="bold">
          この企業が募集中のほかの求人
        </Text>
        <div>
          <RelationInformationList
            relationInfoList={relationInfoList}
            isFetchedAllInfoList={isFetchedAllInfoList}
            handleFetchPaginate={fetchRelationInfoListPaginate}
            isOpen={isOpen}
            toggle={toggle}
          />
        </div>
      </div>
    </section>
  );
};
